import { Injectable } from '@angular/core';
import { Device } from '@ionic-native/device';
import { Platform } from 'ionic-angular';
import { Constants } from '../constants';

@Injectable()
export class DeviceService {

    public wallTabletModels: Array<String> = Constants.WALL_TABLET_MODELS;
    public wallTabletManufacturers: Array<String> = Constants.WALL_TABLET_MANUFACTURERS;

    constructor(
        private device: Device,
        private platform: Platform,
    ) {
    }

    public isWallTablet(){
        if(!this.isMobile())
            return false;
        if(this.wallTabletManufacturers.indexOf(this.device.manufacturer) === -1)
            return false;
        
        if(this.wallTabletModels.indexOf(this.device.model) === -1)
            return false;

        return true;
    }

    public isMobile(){
        return (this.platform.is('android') || this.platform.is('ios')) 
            && (this.platform.is('tablet') || this.platform.is('mobile'));
    }
}



// WEBPACK FOOTER //
// ./src/providers/device/device.service.ts